const apiHostName = process.env.REACT_APP_API_HOST_NAME;

async function setHeaders(user) {
  const headers = {
    'Content-Type': 'application/json',
  };
  if(!user) {
    console.error(`User can not be null for data fetch`)
    return headers;
  }
  const token = await user.getIdToken(false);
  headers['Authorization'] = `Bearer ${token}`;
  return headers
}

async function get(endpoint, user, responseType = 'json') {
  const headers = await setHeaders(user);

  const response = await fetch(`${apiHostName}${endpoint}`, {
    method: 'GET',
    headers: headers
  });

  if (response.status === '404'){
    console.log(`${apiHostName}${endpoint} - ${response.status}`)
    return null;
  }

  if (response.ok) {
    if (responseType === 'blob') {
      return await response.blob();
    }
    return await response.json();
  }

  console.error(`Failed to fetch ${apiHostName}${endpoint}`, response.status);
  return null;
}

async function post(endpoint, data, user, responseType = 'json') {
  const headers = await setHeaders(user);

  const response = await fetch(`${apiHostName}${endpoint}`, {
    method: 'POST',
    headers: headers,
    body: JSON.stringify(data),
  });

  if (!response.ok) {
    console.error(`Failed to fetch ${apiHostName}${endpoint}`, response.status);
    return null;
  }

  if (responseType === 'blob') {
    return await response.blob();
  }

  return await response.json();
}

async function put(endpoint, data, user, responseType = 'json') {
  const headers = await setHeaders(user);

  const response = await fetch(`${apiHostName}${endpoint}`, {
    method: 'PUT',
    headers: headers,
    body: JSON.stringify(data),
  });

  if (!response.ok) {
    console.error(`Failed to fetch ${apiHostName}${endpoint}`, response.status);
    return null;
  }

  if (responseType === 'blob') {
    return await response.blob();
  }

  return await response.json();
}

async function create_place_photo_url_with_token(user, place) {
  const token = await user.getIdToken(false);
  return `${apiHostName}/place/${place.reference}/photo?access_token=${token}`
}

function create_place_photo_url(place) {
  return `${apiHostName}/place/${place.reference}/photo`
}

const apiService = {
  get,
  put,
  post,
  create_place_photo_url_with_token,
  create_place_photo_url,
  apiHostName,
}

export default apiService
